import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'truncateAfterNth',
    pure: true
})
export class TruncateAfterNthPipe implements PipeTransform {
    transform(
        value: string,
        nth: number = 1,
        separator: string = ',',
        includeNth: boolean = false
    ): string {
        if (!value || typeof value !== 'string') return '';

        const parts = value.split(separator);
        const len = parts.length;

        let index = nth >= 0 ? nth : len + nth;

        if (index < 0) index = 0;
        if (index > len) return value;

        const sliceEnd = includeNth ? index + 1 : index;

        return parts.slice(0, sliceEnd).join(separator).trim();
    }
}
